import { QueryClient } from "@tanstack/react-query";

// Configuración del QueryClient para React Query
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Tiempo de vida del cache por defecto (5 minutos)
      staleTime: 5 * 60 * 1000,
      // Tiempo de cache por defecto (10 minutos)
      gcTime: 10 * 60 * 1000,
      // Reintentos por defecto
      retry: 2,
      // 🔄 OPTIMIZACIÓN PARA MÓVILES: Refetch más inteligente
      refetchOnWindowFocus: (query) => {
        // Solo refetch si la query es crítica y no está en segundo plano hace mucho
        const isCriticalQuery =
          query.queryKey.includes("calendar-reservations") ||
          query.queryKey.includes("zonas");

        if (!isCriticalQuery) return false;

        // Verificar si la app estuvo en segundo plano por más de 30 segundos
        const lastFocusTime = query.state.dataUpdatedAt;
        const timeSinceLastFocus = Date.now() - lastFocusTime;

        return timeSinceLastFocus > 30000; // Solo refetch si pasaron más de 30s
      },
      // Refetch automático cuando se reconecta la red
      refetchOnReconnect: true,
    },
    mutations: {
      // Reintentos por defecto para mutaciones
      retry: 1,
    },
  },
});
